export default "__VITE_ASSET__bJas2yNU__"